module.exports = __webpack_public_path__ + "static/media/Img-03.5eee0190.jpg";